import { apiGet, apiPost, apiPut, apiDelete } from './client';

export interface EmployeeExtraCostType {
  id: number;
  name: string;
  recurring: boolean;
  frequencyMonths: number | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface CreateExtraCostTypeInput {
  name: string;
  recurring?: boolean;
  frequencyMonths?: number | null;
}

export interface UpdateExtraCostTypeInput {
  name?: string;
  recurring?: boolean;
  frequencyMonths?: number | null;
}

export async function getExtraCostTypes(): Promise<EmployeeExtraCostType[]> {
  const res = await apiGet<{ data: EmployeeExtraCostType[] }>('/admin/employee-extra-cost-types');
  return res.data;
}

export async function getExtraCostTypeById(id: number): Promise<EmployeeExtraCostType> {
  const res = await apiGet<{ data: EmployeeExtraCostType }>(`/admin/employee-extra-cost-types/${id}`);
  return res.data;
}

export async function createExtraCostType(input: CreateExtraCostTypeInput): Promise<EmployeeExtraCostType> {
  const res = await apiPost<{ data: EmployeeExtraCostType }>('/admin/employee-extra-cost-types', input);
  return res.data;
}

export async function updateExtraCostType(id: number, input: UpdateExtraCostTypeInput): Promise<EmployeeExtraCostType> {
  const res = await apiPut<{ data: EmployeeExtraCostType }>(`/admin/employee-extra-cost-types/${id}`, input);
  return res.data;
}

export async function deleteExtraCostType(id: number): Promise<void> {
  await apiDelete<{ data: { success: boolean } }>(`/admin/employee-extra-cost-types/${id}`);
}
